import Close from '@mui/icons-material/Close';
import { Button, Divider, IconButton, Paper, Snackbar, Stack, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { ReactNode } from 'react';
import { IS_BULK_ACTIONS_ENABLED } from 'v2/constants';

interface Props {
  selectedCount: number;
  onSelectAllCurrentPage: () => void;
  onClearSelection: () => void;
  actions?: ReactNode;
}

const DataGridSelectionToolbar: React.FC<Props> = ({
  selectedCount,
  onSelectAllCurrentPage,
  onClearSelection,
  actions
}) => {
  const { translation } = useTranslation();
  const theme = useTheme();

  if (!IS_BULK_ACTIONS_ENABLED) return null;

  return (
    <Snackbar
      open={selectedCount > 0}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={null}
      onClose={(_, reason) => {
        if (reason !== 'clickaway') onClearSelection();
      }}
      sx={{ width: { xs: 'calc(100% - 32px)', md: 'auto' }, maxWidth: '100%' }}
    >
      <Paper
        elevation={8}
        sx={{
          width: 'fit-content',
          maxWidth: '100%',
          background: theme.custom.background.level1,
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2" whiteSpace="nowrap">{`${selectedCount} ${translation.selected}`}</Typography>
            <Button
              variant="text"
              color="inherit"
              onClick={onSelectAllCurrentPage}
              sx={{
                ...theme.typography.body2,
                minWidth: 0,
                p: 0,
                textDecoration: 'underline',
                textTransform: 'none'
              }}
            >
              {translation.select_all}
            </Button>
          </Stack>
          <IconButton onClick={onClearSelection} aria-label={translation.close} sx={{ flexShrink: 0 }}>
            <Close />
          </IconButton>
        </Stack>
        <Divider sx={{ mx: 2 }} />
        <Stack direction="row" flexWrap="wrap" gap={1} sx={{ p: 1.5 }}>
          {actions}
        </Stack>
      </Paper>
    </Snackbar>
  );
};

export default DataGridSelectionToolbar;
